<template>
    <div class="modal fade" id="delete_module_modal" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{$lang('Usunięcie modułu')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    {{ $lang('Czy na pewno chcesz usunąć ') + name + '?'}}
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default"
                            data-dismiss="modal">{{$lang('Nie')}}
                    </button>
                    <button class="btn btn-primary" v-on:click="deleteModule" data-dismiss="modal">
                        {{$lang('Tak')}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import ShowNotification from "../../mixins/show-notification";

    export default {
        name: 'library-module-delete',
        mixins: [ShowNotification],
        props: ['module', 'delete_route'],
        data() {
            return {
                name: (this.module!=null ? this.module.name : ''),
                id: (this.module!=null ? this.module.id : ''),
            }
        },
        watch: {
            module: {
                deep: true,
                handler() {
                    if (this.module !== null) {
                        this.id = this.module.id;
                        this.name = this.module.name;
                    }
                }
            }
        },
        methods: {
            deleteModule() {
                const self = this;
                axios.post(this.delete_route, {
                    id: this.id
                })
                    .then(function () {
                        self.$parent.getUserModules();
                        self.showNotification('success', 'Pomyślnie usunięto moduł!');

                    })
                    .catch(error => {
                        self.showNotification('error', 'Nie udało się usunąć modułu!');
                    });
            }
        }
    }
</script>
